(function () {
  'use strict';

  var DEFAULT_CUT_H = 14;
  var DEFAULT_CUT_M = 30;
  var DEFAULT_TZ = 'America/Phoenix';
  var DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var SHIP_COUNTDOWN_SELECTOR = '[data-dd-ship-countdown], [data-dd-sf-ship-instock-text]';

  function readCutoffFromRoot(root, cfg) {
    if (!root) return cfg;
    var h = parseInt(root.getAttribute('data-cutoff-hour'), 10);
    if (!isNaN(h)) cfg.cutoffHour = h;
    var m = parseInt(root.getAttribute('data-cutoff-minute'), 10);
    if (!isNaN(m)) cfg.cutoffMinute = m;
    var t = root.getAttribute('data-cutoff-tz');
    if (t) cfg.tz = t;
    return cfg;
  }

  function getCutoffConfig() {
    var cfg = { cutoffHour: DEFAULT_CUT_H, cutoffMinute: DEFAULT_CUT_M, tz: DEFAULT_TZ };
    var root =
      document.querySelector('[data-dd-cart-items][data-cutoff-hour]') ||
      document.querySelector('#main-cart-items[data-cutoff-hour]') ||
      document.querySelector('[data-dd-trust-shipping][data-cutoff-hour]') ||
      document.querySelector('[data-dd-sf-ship][data-cutoff-hour]') ||
      document.querySelector('[data-dd-cart-items]') ||
      document.getElementById('main-cart-items');
    return readCutoffFromRoot(root, cfg);
  }

  function tzCalendarDate(date, tz) {
    try {
      var formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: tz,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      });
      var parts = {};
      var formatted = formatter.formatToParts(date);
      for (var i = 0; i < formatted.length; i++) {
        parts[formatted[i].type] = formatted[i].value;
      }
      return new Date(
        parseInt(parts.year, 10),
        parseInt(parts.month, 10) - 1,
        parseInt(parts.day, 10)
      );
    } catch (err) {
      return null;
    }
  }

  function getMsUntilNextCutoff(cutoffHour, cutoffMinute, tz) {
    var cal = window.DDShippingCalendar;
    if (cal && typeof cal.getMsUntilNextCutoff === 'function') {
      return cal.getMsUntilNextCutoff(cutoffHour, cutoffMinute, tz);
    }
    return NaN;
  }

  function nextCutoffShipDate(cutoffHour, cutoffMinute, tz) {
    var ms = getMsUntilNextCutoff(cutoffHour, cutoffMinute, tz);
    if (isNaN(ms) || ms < 0) return null;
    return tzCalendarDate(new Date(Date.now() + ms), tz);
  }

  function sameCalendarDay(a, b) {
    return (
      a &&
      b &&
      a.getFullYear() === b.getFullYear() &&
      a.getMonth() === b.getMonth() &&
      a.getDate() === b.getDate()
    );
  }

  function shipPillInfo(shipDate, today) {
    if (!shipDate || !today) {
      return { label: 'Ships soon', tier: 'later' };
    }
    if (sameCalendarDay(shipDate, today)) {
      return { label: 'Ships today', tier: 'today' };
    }
    var tomorrow = new Date(today.getTime());
    tomorrow.setDate(tomorrow.getDate() + 1);
    if (sameCalendarDay(shipDate, tomorrow)) {
      return { label: 'Ships tomorrow', tier: 'tomorrow' };
    }
    if (shipDate.getDay() === 1) {
      return { label: 'Ships Monday', tier: 'monday' };
    }
    return { label: 'Ships ' + DAY_NAMES[shipDate.getDay()], tier: 'later' };
  }

  function getPillInfo(cfg) {
    cfg = cfg || getCutoffConfig();
    var today = tzCalendarDate(new Date(), cfg.tz);
    var shipDate = nextCutoffShipDate(cfg.cutoffHour, cfg.cutoffMinute, cfg.tz);
    return shipPillInfo(shipDate, today);
  }

  function applyLabel(el, info) {
    el.textContent = info.label;
  }

  function update() {
    var els = document.querySelectorAll(SHIP_COUNTDOWN_SELECTOR);
    if (!els.length) return;
    var info = getPillInfo();
    for (var i = 0; i < els.length; i++) applyLabel(els[i], info);
  }

  window.DDShipCountdown = {
    getCutoffConfig: getCutoffConfig,
    getPillInfo: getPillInfo,
    applyLabel: applyLabel,
    update: update,
    selector: SHIP_COUNTDOWN_SELECTOR,
  };
  window.__ddShipCountdownUpdate = update;

  if (window.__ddShipCountdown) {
    update();
    return;
  }
  window.__ddShipCountdown = true;

  update();
  setInterval(update, 60000);

  var _rafScheduled = false;
  function scheduleUpdate() {
    if (_rafScheduled) return;
    _rafScheduled = true;
    requestAnimationFrame(function () {
      _rafScheduled = false;
      update();
    });
  }

  var roots = [
    document.querySelector('cart-drawer'),
    document.getElementById('main-cart-items'),
    document.querySelector('dd-sticky-footer'),
  ];
  for (var i = 0; i < roots.length; i++) {
    if (roots[i] && window.MutationObserver) {
      new MutationObserver(scheduleUpdate).observe(roots[i], { childList: true, subtree: true });
    }
  }

  document.addEventListener('drawer:opened', scheduleUpdate);
  document.addEventListener('cart:updated', scheduleUpdate);
})();
